import(/* webpackMode: "eager" */ "/app/src/app/faq/page.tsx");
